import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private readonly sidebarToggleSubject = new Subject<void>();
  get sidebarToggle$(){
    return this.sidebarToggleSubject.asObservable();
  }
  toggleSidebar() {
    this.sidebarToggleSubject.next();
  }
}
